import { Extension } from "@tiptap/core";

import type { Editor } from "@tiptap/core";
import type { useTranslations } from "next-intl";

export type Translator = ReturnType<typeof useTranslations<"tiptap">>;

export type EditorTranslatorOptions = {
  translator: Translator | null;
};

export type EditorTranslatorStorage = {
  translator: Translator | null;
};

declare module "@tiptap/core" {
  interface Storage {
    editorTranslator: EditorTranslatorStorage;
  }
}

export const EditorTranslator = Extension.create<EditorTranslatorOptions, EditorTranslatorStorage>({
  name: "editorTranslator",

  addOptions() {
    return { translator: null };
  },

  addStorage() {
    return { translator: this.options.translator };
  },
});

export function editorTranslator(editor: Editor): Translator | null {
  return editor.storage.editorTranslator?.translator ?? null;
}
